import { Component, OnInit } from '@angular/core';
import { AuthService, JobsStoreService, WarehouseStoreService } from '../../_shared/services';
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap } from "rxjs/operators";
import { forkJoin, of, Subject } from "rxjs";
import { JobsList, WarehouseSerialSearch } from "../../_shared/interfaces";
import { Router, RouterLink } from "@angular/router";

import PackageJson from "../../../../package.json";
import '@cds/core/icon/register.js';

import { ClrDropdownModule } from "@clr/angular";
import { LanguageSelectorComponent } from "../language-selector/language-selector.component";
import { NgForOf, NgIf } from "@angular/common";
import { TranslocoDirective } from "@jsverse/transloco";
import { ThemeToggleComponent } from "../theme-toggle/theme-toggle.component";

import { environment } from "../../../environments/environment";
import { ClarityIcons, cogIcon, userIcon } from '@cds/core/icon';
import { BrandingAssets, BrandingService } from "../../_shared/services/branding.service";
import { getTenantStorage } from "../../_shared/utils/tenant-context";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    ClrDropdownModule,
    LanguageSelectorComponent,
    NgIf,
    NgForOf,
    RouterLink,
    TranslocoDirective,
    ThemeToggleComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.sass'
})
export class HeaderComponent implements OnInit {
  public firstName: string = '';
  public surName: string = '';
  public tester: boolean = false;
  public devMode: boolean = false;
  public stage: string;
  public branding: BrandingAssets;

  // Search components
  keyUp$ = new Subject<string>();

  onKeyUp(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    this.keyUp$.next(inputElement.value);
  }

  isLoading = false;
  foundJobs: JobsList[] = [];
  foundSerials: WarehouseSerialSearch[] = [];

  public ppsversion: string = PackageJson.version;

  constructor(
    private jobss: JobsStoreService,
    private waress: WarehouseStoreService,
    public authService: AuthService,
    private router: Router,
    private brandingService: BrandingService
  ) {
    this.devMode = environment.stages.dev;
    this.stage = environment.stages.name;
    this.branding = this.brandingService.getAssets();
    ClarityIcons.addIcons(cogIcon, userIcon);
  }

  ngOnInit() {
    this.firstName = getTenantStorage('first_name') || '';
    this.surName = getTenantStorage('last_name') || '';
    this.tester = this.authService.checker;

    // Search serial/heat numbers in job positions and the warehouse ledger in parallel
    this.keyUp$.pipe(
      filter(term => term.length >= 3),
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      switchMap(searchTerm => forkJoin({
        jobs: this.jobss.searchJobPositionBySerialNumber(searchTerm).pipe(catchError(() => of({ object: [] as JobsList[] }))),
        serials: this.waress.searchSerial(searchTerm).pipe(catchError(() => of({ object: [] as WarehouseSerialSearch[] }))),
      })),
      tap(() => this.isLoading = false)
    )
      .subscribe(result => {
        this.foundJobs = result.jobs.object ?? [];
        this.foundSerials = result.serials.object ?? [];
      });
  }

  goToJob(projectID: string, jobID: string) {
    this.router.navigate([`job/details/${projectID}/${jobID}`]);
  }

  goToWarehouse(hit: WarehouseSerialSearch) {
    const queryParams: Record<string, string> = {};
    if (hit.serial_nr) queryParams['serial'] = hit.serial_nr;
    else if (hit.heat_nr) queryParams['heat'] = hit.heat_nr;
    if (hit.technical_drawing) queryParams['drawing'] = hit.technical_drawing;
    this.router.navigate(['/warehouse/overview'], { queryParams });
  }

  logoutUser() {
    this.authService.doLogout();
  }
}
